import { render, staticRenderFns } from "./ModalFondearDisposicion.vue?vue&type=template&id=61136024&"
import script from "./ModalFondearDisposicion.vue?vue&type=script&lang=js&"
export * from "./ModalFondearDisposicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports